/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import AbstractCaseTranslations from "./abstractCaseTranslations";

const familyLawCaseTranslations = {
  label: "Erstberatung",
  personalTextMessage: {
    label: "Ihre Anliegen",
  },
  ...AbstractCaseTranslations,
};

export default familyLawCaseTranslations;
